module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("T")]), _vm._v("his book is dedicated to my parents, Maria Rosaria and Benedetto, for all the great support that they give me during the creation of my books. Thanks to their precious advice of ‘veteran’ teachers, my researches are clearly much better. A very special thanks goes to Philip Sidnell, the commissioning editor of my books for Pen & Sword: this new series, which starts with the present book, exists thanks to his great intelligence and positive vision. Everything began with a simple idea, during a very hot summer: now that project is coming to fruition. Last but not least, a special mention goes to the production manager of this title, Matt Jones, for his great competence. All the pictures published in this book are public domain ones obtained from the magnificent Digital Collections of the Brown University Library, in particular from the incredible Anne S.K. Brown Military Collection. The vast contents of the latter can be easily browsed at: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://https://library.brown.edu/info/collections/askb/prints/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://library.brown.edu/info/collections/askb/prints/")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0a33c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0